/* eslint-disable react/react-in-jsx-scope */
import { useNavigate } from "react-router"
import { useState, useContext } from 'react';
// import { UserContext, UserDispatchContext } from '../contexts/testContext';
import { useUserContext, useUserDispatch } from '../contexts/testContext';


function Test1({ children }) {
    // const userCon = useContext(UserContext);
    // const dispatch = useContext(UserDispatchContext);
    const userCon = useUserContext();
    const dispatch = useUserDispatch();
    const navigate = useNavigate();

    const [user, setUser] = useState({
        email: "",
        password: "",
      });
    
      const handleInput = (e) => {
        const { name, value } = e.target;
        setUser((prev) => ({
          ...prev,
          [name]: value,
        }));
      };
    
      const handleLogin = () => {
        console.log(user);
        dispatch({
            type: 'login',
            user: user,
          });
      }
     
      const handleLogout = () => {
        //
        dispatch({
            type: 'logout',
          });
      }

    //   console.log(state);
   
    // console.log(userCon);

  return (
        <>
        
        <section className="section">
         <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
                <form id="FormLogin" method="POST" className="space-y-6">
                    <div>
                        <label htmlFor="email" className="block text-sm/6 font-medium text-gray-400">
                            Email address
                        </label>
                        <div className="mt-2">
                            <input
                            id="email"
                            name="email"
                            type="email"
                            required
                            autoComplete="email"
                            className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-600 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
                            onChange={handleInput}
                            />
                        </div>
                    </div>

                    <div>
                        <div className="flex items-center justify-between">
                            <label htmlFor="password" className="block text-sm/6 font-medium text-gray-400">
                            Password
                            </label>
                        </div>
                        <div className="mt-2">
                            <input
                            id="password"
                            name="password"
                            type="password"
                            required
                            autoComplete="off"
                            className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-600 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
                            onChange={handleInput}
                            />
                        </div>
                    </div>

                    <div className="flex items-center justify-center p-4">
                        <button
                            type="button"
                            className="flex mx-4 justify-center rounded-md bg-indigo-600 px-3 py-1.5 text-sm/6 font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                            onClick={() => {
                                dispatch({
                                    type: 'login',
                                    user: user,
                                });
                            }}
                        >
                            Sign in
                        </button>
                        <button
                            type="button"
                            className="flex mx-4 justify-center rounded-md bg-red-600 px-3 py-1.5 text-sm/6 font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                            onClick={() => {
                                dispatch({
                                    type: 'logout',
                                });
                            }}
                        >
                            Sign out
                        </button>
                    </div>
                </form>
            </div>

            <span>Test1: {userCon?.user.email}</span>
            {/* <UserContext.Provider value={userCon}> */}
                {children}
            {/* </UserContext.Provider> */}
        </section>
    </>
    )
}

export default Test1